import { useEffect } from "react";

const SITE_LOGIN_HTML_ATTR = "data-home-v2";

/** Page-level HomeV3 chrome on `<html>` (language prompt, promo close, etc.). Login body is global via LoginWrapper. */
const useSiteHeaderLoginModal = (): void => {
  useEffect(() => {
    document.documentElement.setAttribute(SITE_LOGIN_HTML_ATTR, "");
    return () => {
      document.documentElement.removeAttribute(SITE_LOGIN_HTML_ATTR);
    };
  }, []);
};

export default useSiteHeaderLoginModal;

export { HOME_V2_LOGIN_SHEET_CLASS } from "./siteLoginModalOverride";
